import { inject, Service } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { firstValueFrom, race, throwError, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { IWebConfig } from 'src/app/shared/model/IWebConfig';
import { WebConfigService } from '../web-config/web-config.service';

@Service()
export class DowntimeService {
  #webconfig: IWebConfig = inject(WebConfigService);
  #logger = inject(NGXLogger);
  public downtimeStatusCode: number = 503;

  async getDowntimeStatus(): Promise<boolean> {
    const requests = [
      fetch(`${this.#webconfig.baseUrls.auth}/healthz`).then(this.checkServiceAvailability),
      fetch(`${this.#webconfig.baseUrls.kernel}/healthz`).then(this.checkServiceAvailability),
      fetch(`${this.#webconfig.baseUrls.app}/healthz`).then(this.checkServiceAvailability),
    ];

    const timeout$ = timer(5000).pipe(switchMap(() => throwError(() => new Error('Request timed out'))));

    try {
      const responses = await firstValueFrom(
        race(
          Promise.all(requests).then((r) => r),
          timeout$,
        ),
      );
      if ((responses as string[]).some((res) => res === 'Service is down')) {
        this.#logger.error('Services are down');
        return true;
      }
      return false;
    } catch (error) {
      if (error.message === 'Request timed out' || error.message === 'Failed to fetch') {
        this.#logger.error('Failed to connect to the server.', error.message);
        return true;
      }
      this.#logger.error('Error checking downtime status:', error.message);
      return true;
    }
  }
  checkServiceAvailability(response) {
    if (response.status === 503) {
      return 'Service is down';
    }
    return response;
  }
}
